import React, { useCallback, useEffect, useMemo } from "react";

import { sfxInLogout } from "@app/statefx/xThunks/login";

import { useAppDispatch, useAppSelector } from "../state";
import { insLogout } from "../state/insider/login";
// import { service } from "../service";
// import { useFusionAuth } from "@fusionauth/react-sdk";
import {
  fusionLogin,
  fusionLogout,
  fusionRefreshSession,
  fusionRegister,
  resetGroupData,
  resetUsersData,
  setUiDrawerItems,
  testLoginStatus,
  whoami,
  whoamiSelect,
} from "../state/units";
import { useFxDispatch, useFxSelector } from "../statefx";

import type { IAppFusionCtx, IWhoAmI } from "../types";
const AppFusionCtx = React.createContext({} as any);

export const AppFusion = ({ children }: { children: any }) => {
  const [userdata, setUserData] = React.useState<IWhoAmI>({} as any);
  const dispatch = useAppDispatch();
  const user = useAppSelector(whoamiSelect);

  useEffect(() => {
    setUserData(user);
    // after login //
    if (user?.email && user?.email_verified) {
      dispatch(setUiDrawerItems());
    }
  }, [user?.email, user?.email_verified]);

  useEffect(() => {
    dispatch(whoami());
  }, []);

  return (
    <AppFusionCtx.Provider value={userdata}>{children}</AppFusionCtx.Provider>
  );
};

export const useAppFusion = (): IAppFusionCtx => {
  const value = React.useContext(AppFusionCtx) as IWhoAmI;
  const dispatch = useAppDispatch();
  const fxDispatch = useFxDispatch();

  const login = useCallback(() => {
    dispatch(fusionLogin());
  }, []);

  const logout = useCallback(() => {
    dispatch(resetGroupData());
    dispatch(resetUsersData());
    dispatch(insLogout());
    dispatch(fusionLogout());
    fxDispatch(sfxInLogout());
  }, []);

  const register = useCallback(() => {
    dispatch(fusionRegister());
  }, []);

  const refreshToken = () => {
    dispatch(fusionRefreshSession());
  };
  const drytest = () => {
    dispatch(whoami());
  };
  const isAuthenticated = useMemo(() => {
    return Boolean(value?.email);
  }, [value.email]);

  const isVerifiedEmail = useMemo(() => {
    return Boolean(isAuthenticated && value?.email_verified);
  }, [isAuthenticated, value.email_verified]);

  const isRegisteredUser = useMemo(() => {
    // REGUSER is default role for all users //
    return Boolean(
      isVerifiedEmail &&
        value?.roles?.length &&
        Number.isInteger(value?.ALGID) &&
        (value?.ALGID || -1) > 0
    );
  }, [isVerifiedEmail, value.ALGID]);
  return {
    login,
    logout,
    register,
    user: value,
    isAuthenticated,
    isVerifiedEmail,
    isRegisteredUser,
    refreshToken,
    drytest,
  };
};
